import clsx from "clsx";
import React from "react";
import { Text } from "web/react/emo/text";
import { RailCardSerializer } from "web/types/serializers";
import styles from "./related-rail-card.module.css";

interface RelatedRailCardProps {
    candidate: RailCardSerializer;
}

export function RelatedRailCard({ candidate }: RelatedRailCardProps): React.ReactElement {
    return (
        <div data-testid="retailer-rail-card" className={styles.candidateCard}>
            {candidate.image_url && (
                <a href={candidate.url}>
                    <img
                        src={candidate.image_url}
                        alt={candidate.name}
                        className={clsx(styles.candidateImage)}
                    />
                </a>
            )}
            <a href={candidate.url}>
                <Text className={styles.candidateName} as="p" textStyle="footnote">
                    {candidate.name}
                </Text>
            </a>
        </div>
    );
}
